// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5f8b4405","385":"03707f76","724":"d426fa81","767":"ea83620b","841":"3681e387","890":"4fbc157e","900":"421f842c"}[chunkId] + ".chunk.js";
};